<template>
  <div class="dizaym">
    <div v-if="checkerDisplayOffers.length" class="main-title">Лучшие предложения</div>

    <div class="checker-card" v-for="checkerOffer in checkerDisplayOffers" :key="'checker-' + (checkerOffer.id || checkerOffer.link || checkerOffer.name)">
      <div class="checker-card__wrapper">
        <div class="checker-card__left">
          <div class="checker-title">
            <div class="checker-title__logo">
              <img :src="'https://zanimakus.ru' + checkerOffer.logo" alt="" />
            </div>

            <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper">
              <div class="checker-title__text1">
                <img src="/img/fire.png" alt="">
                <span>{{ checkerOffer.privilege1 }}</span>
              </div>
              <div class="checker-title__text2">
                <span>{{ checkerOffer.privilege2 }}</span>
              </div>
            </div>
          </div>

          <div class="checker-name">Вам одобрен займ <br>в {{ checkerOffer.name }}</div>

          <div class="checker-data">
            <div class="checker-data__text">
              <div>Сумма:</div><span>{{ numberFormat(checkerOffer.amount) }} ₽</span>
            </div>
            <div class="checker-data__text">
              <div>Срок:</div><span>{{ checkerOffer.period }} дн.</span>
            </div>
            <div class="checker-data__text">
              <div>Ставка:</div><span>{{ getCheckerPercentValue(checkerOffer) }} %</span>
            </div>
          </div>

          <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper__mob">
            <div class="checker-title__text1">
              <img src="/img/fire.png" alt="">
              <span>{{ checkerOffer.privilege1 }}</span>
            </div>
            <div class="checker-title__text2">
              <span>{{ checkerOffer.privilege2 }}</span>
            </div>
          </div>

          <div @click="openLinks(checkerOffer)" class="checker-button">
            <button>ПОЛУЧИТЬ ДЕНЬГИ</button>
          </div>
          <div class="checker-info">{{ checkerOffer.legal_info }}</div>
        </div>

        <div class="checker-card__right">
          <img src="/img/t-showcasev1-girl.png" alt="">
        </div>
      </div>
    </div>

    <div v-if="checkerDisplayOffers.length" class="main-title">Также для вас</div>

    <template v-if="isSwiperEnabled">
      <div class="showcase-wrapper">
        <div class="swiper-pagination" ref="pagination"></div>
        <div class="swiper-text__label">Листайте влево</div>
        <div class="swiper showcase-swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
              <div class="card" >
                <div class="card-top">
                  <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
                </div>
                <div class="card-info__rate">
                  <star-rating :max="5" :current="offer.rating"></star-rating>
                </div>

                <div class="card-info">
                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/dsum.svg" alt="">
                    </div>
                    <div class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</div>
                  </div>
                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/dperiod.svg" alt="">
                    </div>
                    <div class="card-info__value">до {{ offer.period }} дней</div>
                  </div>
                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/dpercent.svg" alt="">
                    </div>
                    <div class="card-info__value">без % -  <span v-if="offer.without_percent">да</span>
                    <span v-if="!offer.without_percent" >нет</span></div>
                  </div>
                </div>

                <div class="card-btn" @click="openLinks(offer)">
                  <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
                </div>
              </div>
            </div>
          </div>

          <button class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }">‹</button>
          <button class="showcase-nav next" ref="nextBtn">›</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="showcase-wrapper showcase-wrapper--no-swiper">
        <div class="card" v-for="offer in showcaseOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
          <div class="card-top">
            <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
          </div>
          <div class="card-info__rate">
            <star-rating :max="5" :current="offer.rating"></star-rating>
          </div>

          <div class="card-info">
            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/dsum.svg" alt="">
              </div>
              <div class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</div>
            </div>
            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/dperiod.svg" alt="">
              </div>
              <div class="card-info__value">до {{ offer.period }} дней</div>
            </div>
            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/dpercent.svg" alt="">
              </div>
              <div class="card-info__value">без % -  <span v-if="offer.without_percent">да</span>
              <span v-if="!offer.without_percent" >нет</span></div>
            </div>
          </div>

          <div class="card-btn" @click="openLinks(offer)">
            <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import StarRating from "@/components/StarRating";
import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
export default {
  name: "ShowcaseDizaym",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: {
    StarRating,
  },
  props: {
    offers: Array,
    checkerOffers: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    ratingText: Data.getRatingText(),
    buttonText: Data.getButtonText(),
  }),

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return Array.isArray(this.checkerOffers) ? this.checkerOffers : [];
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },
  },

  methods: {

    numberFormat(n) {
      return Functions.numberFormat(n);
    },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      offer.links.forEach(l => window.open(l, "_blank"));
    },

    normalizeCheckerPrivilege(value) {
      return String(value ?? "").replace(/[\s\u00A0\u200B-\u200D\uFEFF]+/g, "").trim();
    },

    getFallbackCheckerPercent(checkerOffer) {
      const variants = ["0", "0.1", "0.3", "0.5", "0.7", "0.9", "1"];
      const seed = this.getOfferKey(checkerOffer) || "checker-percent";
      let hash = 0;

      for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
      }

      return variants[hash % variants.length];
    },

    hasCheckerPrivileges(checkerOffer) {
      const privilege1 = this.normalizeCheckerPrivilege(checkerOffer?.privilege1);
      const privilege2 = this.normalizeCheckerPrivilege(checkerOffer?.privilege2);

      return privilege1 !== "" && privilege2 !== "";
    },

    getCheckerPercentValue(checkerOffer) {
      const percent = this.normalizeCheckerPrivilege(checkerOffer?.percent_mfo);
      return percent !== "" ? percent : this.getFallbackCheckerPercent(checkerOffer);
    },
  }
};
</script>
<style lang="css">
@import url(../assets/css/dizaym.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.ozzaym .card-info__wrapper {

  display: flex;
  align-items: center;

}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}

.swiper-text__label{
  display: none;
}

@media (max-width: 768px) {
  .dizaym .swiper-text__label{
  display: block;
  font-weight: 400;
  font-size: 16px;
  }
  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}
/* ===========================
   ДЕСКТОП (старый вид, без свайпера)
   =========================== */

@media (min-width: 768px) {

  /* полосы и стрелки вообще не показываем */
  .showcase-wrapper>.swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  /* обычная сетка карточек */
  .dizaym .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: flex-start;
    /* или center, если хочешь по центру */
  }

  .dizaym .showcase-swiper .swiper-slide {
    flex: 0 0 355px;
    /* ЖЁСТКАЯ ширина колонки */
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .dizaym .showcase-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }
}

/* ===========================
   МОБИЛКА (Swiper + прогресс + стрелки)
   =========================== */
@media (max-width: 767px) {

  .dizaym .showcase-wrapper {
    padding: 0 0 20px;
  }

  .dizaym .showcase-wrapper--no-swiper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0;
    align-items: stretch;
  }

  .dizaym .showcase-wrapper--no-swiper .card {
    max-width: 100%;
    width: 100%;
  }

  .dizaym .showcase-wrapper--no-swiper .swiper-text__label,
  .dizaym .showcase-wrapper--no-swiper .swiper-pagination,
  .dizaym .showcase-wrapper--no-swiper .showcase-nav {
    display: none !important;
  }

  /* ПРОГРЕССБАР СВЕРХУ */
  .dizaym .showcase-wrapper>.swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    /* как карточка */
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    /* ЦЕНТРИРУЕМ */
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .dizaym .showcase-wrapper>.swiper-pagination .swiper-pagination-progressbar-fill {
    background: linear-gradient(90deg, #D80000 0%, #F44 100%);
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    /* чтобы стрелки не обрезались */
    position: relative;
  }

  .dizaym .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  /* СТРЕЛКИ */
  .dizaym .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: linear-gradient(90deg, #D80000 0%, #F44 100%);
    border-radius: 50%;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .dizaym .showcase-wrapper {
    flex-direction: row;
  }

  .dizaym .showcase-wrapper--no-swiper {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: stretch !important;
  }

  .dizaym .showcase-wrapper--no-swiper .card {
    max-width: 100% !important;
    width: 100% !important;
  }
}
</style>

